import {getQueryParamValue} from "./getQueryParamValue.js";
import {getTenantHostName} from "./TenantService.js";
import {cancelledStates} from "./consignmentStates.js";
import {sortAndCheckDeliveries} from "./sortData.js";
import {setConsigneeStatesOnlyMap, setPage} from "./setData.js";
import {getMapMarkerObject} from "./utils.js";
import {imageBaseUrl} from "./getData.js";

var settings = ({tenantDNS, orderId, tenantId, shipmentId}) => ({
  url: orderId
    ? `https://${tenantDNS}/app/order/v1/api/external/ordertrackingV2/orderId/${orderId}`
    : `https://${tenantDNS}/app/order/v1/api/external/ordertrackingV2/shipmentId/${shipmentId}`,
  method: "GET",
  timeout: 0,
  headers: {
    "x-coreos-request-id": "unAuth1",
    "x-coreos-tid": tenantId,
  },
});

const isCancelled = (events) => {
  for (let i = 0; i < events.length; i++) {
    const ERCODE =
      events[i]?.eventCode +
      (events[i]?.reasonCode ? `-${events[i]?.reasonCode}` : "");

    if (cancelledStates.includes(ERCODE)) return true;
  }

  return false;
};

async function getMapData() {
  // let showRiderDetails = false;
  let isReverseOrder = false;
  const orderId =
    getQueryParamValue("orderID") || getQueryParamValue("orderId");
  const shipmentId = getQueryParamValue("shipmentId");

  const tenantConfig = await getTenantHostName();

  // get data
  $.ajax(
    settings({
      tenantDNS: tenantConfig?.tenantDns,
      orderId,
      tenantId: tenantConfig?.tenantId,
      shipmentId,
    }),
  )
    .done(function (response) {
      // data is loaded correctly
      $(".loader").css("display", "none");

      isReverseOrder = false;

      if (response?.data?.order?.shipmentFlow) {
        isReverseOrder =
          response?.data?.order?.shipmentFlow?.toLowerCase() == "reverse";
      }

      if (isReverseOrder) $("#step-delivered").remove();
      else if (!isReverseOrder) $("#step-return").remove();

      const orgName = response?.data?.orgName;
      // not found or cancelled

      const isOrderCancelled = isCancelled(
        response?.data?.shipmentTracking[0]?.events,
      );

      if (!response?.data?.order?.clientOrderId || isOrderCancelled) {
        const template = notFoundTemplate(orgName, "not-found.svg");
        setPage(template);
        return;
      }

      const sortedEvents = sortAndCheckDeliveries(
        response?.data?.shipmentTracking[0]?.events,
        isReverseOrder,
        response?.data?.order?.state,
      );

      const riderLoc = getMapMarkerObject(
        response?.data?.riderTracking[
          response?.data?.riderTracking?.length - 1
        ],
        "Rider",
        imageBaseUrl + "rider_vehicle.svg",
        "lon",
      );
      const dropLoc = getMapMarkerObject(
        response?.data?.job?.drop?.geolocation,
        "Drop",
        imageBaseUrl + "map-home.svg",
        "long",
      );
      // showRiderDetails = response?.data?.showRiderDetails;

      const markers = {
        riderLoc,
        dropLoc,
      };

      setConsigneeStatesOnlyMap(
        sortedEvents,
        orderId ?? response?.data?.order?.clientOrderId,
        markers,
        isReverseOrder,
        response?.data?.order?.attemptCount,
        response?.data?.order?.state,
      );
    })
    .fail((error) => {
      console.error(error);
    });
}

export default getMapData;
